/*
 * Copyright (c) 2024. . Yantodev - All Rights Reserved.
 * @Author  :  yantodev
 * mailto : ekocahyanto007@gmail.com
 * link : https://yantodev.my.id/
 */

import axios from "axios";

const checkAuth = () => {

    const STATUS_TOKEN = localStorage.getItem("session") ? true : false;
    if (STATUS_TOKEN) {
        const TOKEN = JSON.parse(localStorage.getItem("session"))
        const PUBLIC_ROUTES = ["login", "forgot-password", "register", "documentation", "auth/reset"];

        const isPublicPage = PUBLIC_ROUTES.some(route => window.location.href.includes(route));

        if (!TOKEN && !isPublicPage) {
            redirectToLoginPage();
            localStorage.removeItem('session')
            return null;
        } else {
            setAuthorizationHeader(TOKEN && TOKEN.session.access_token);
            setAxiosInterceptors();
            return TOKEN;
        }
    } else {
        localStorage.removeItem("session");

    }
}

const redirectToLoginPage = () => {
    window.location.href = '/login';
}

const setAuthorizationHeader = (accessToken) => {
    axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
}

const setAxiosInterceptors = () => {
    axios.interceptors.request.use(config => {
        showLoadingIndicator();
        return config;
    }, error => {
        return Promise.reject(error);
    });

    axios.interceptors.response.use(response => {
        hideLoadingIndicator();
        return response;
    }, error => {
        hideLoadingIndicator();
        return Promise.reject(error);
    });
}

const showLoadingIndicator = () => {
    document.body.classList.add('loading-indicator');
}

const hideLoadingIndicator = () => {
    document.body.classList.remove('loading-indicator');
}

export default checkAuth;
